import { baseUrl, baseUrlClaveUnice, BASE_URL_Consultas } from "../config/config";
const sendRequest = async (path, token, method = "GET", body) => {
  const params = {
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      ...(token && {Authorization: `Bearer ${token}`}),
    },
    method,
    ...(body && {body})

  };
  if (path.includes('api/v1/ciudadano?')){
    return await fetch(`${BASE_URL_Consultas}/${path}`, params);
  }else{
    return await fetch(`${baseUrl}/${path}`, params);
  }

}; 
const get = (user, logout,userLoggedIn) => async (path) => {
  const {access} = user || {};
  try {
    const resp = await sendRequest(path, access);
    if(!resp.ok){
      throw resp
    }
    return resp;
  } catch (error) {
    return processResponse(path, "GET", undefined, user, userLoggedIn)(error, logout)
  }
 
};

const processResponse =  (path, method, body, user,userLoggedIn)=> async(error, logout) =>{
  const {refresh} = user || {};
  if(!error){
    return "error"
  }
  try {
    const results = await error.json()
    if(results && results.detail && results.detail.includes("Given token not valid for any token type")){
      let newToken = await refreshToken(refresh)
      if(!newToken.ok){
        logout && logout();
        return error
      }
      const {access:newAccess} = await newToken.json()
      const newUser = {...user, access:newAccess};
      await userLoggedIn(newUser)
      const resp = await sendRequest(path, newAccess, method, body);
      if(!resp.ok){
        logout && logout();
        return error
      }
        return resp;
        
    }
    logout && logout();
    return results;
  } catch (error) {
    logout && logout();
    return error
  }
  
}
//Given token not valid for any token type
const post = (user, logout,userLoggedIn) => async (path, body) => {
  const {access} = user || {}
  try {
    const resp = await sendRequest(path, access, "POST", body);
    if(!resp.ok){
      throw resp
    }
    return resp;
  } catch (error) {
    return processResponse(path, "POST", body, user, userLoggedIn)(error, logout)
  }
};

const delet = (user, logout,userLoggedIn) => async (path, body) => {
  const {access} = user || {}
  try {
    const resp = await sendRequest(path, access, "DELETE", body);
    if(!resp.ok){
      throw resp
    }
    return resp;
  } catch (error) {
    return processResponse(path, "DELETE", body, user, userLoggedIn)(error, logout)
  }
};

export const getCertificate = (user, logout, userLoggedIn) => async (reclamo) => {
  const body = JSON.stringify({
    ux: reclamo["ux"],
    rut: reclamo["identifier"],
    folio: reclamo["folio"],
    tipo: reclamo["tipo"],
    nombre_solicitante: reclamo["nombre_solicitante"],
    tipo_tramite: reclamo["tramitacion"],
    reclamado: reclamo["reclamado"],
    estado_reclamo: reclamo["estado_reclamo"],
    fase: reclamo["fase"],
    materia: reclamo["materia"],
    fecha_ingreso: reclamo["fecha_ingreso"],
    tipo_certificado: reclamo["tipo_certificado"],
 
  })



  let req = await post(user, logout, userLoggedIn)(`tramites/api/v1/getcertificade/`, body);
  if (req.ok) {
    req = await req.json();
    return req;
  }
  return false;
};


export const getExpediente = (user, logout, userLoggedIn) => async (reclamo) => {
   let req = await get(user, logout, userLoggedIn)(`tramites/api/v1/pdfExpedienteView/${reclamo["link_expediente"]}/${reclamo["identifier"]}/${reclamo["folio"]}`);
  if (req.ok) {
    req = await req.json();
    return req;
  }
  return false;
};



 const refreshToken = async refreshToken => {
  return await post()(`cuenta/api/v1/token/refresh/`, JSON.stringify({refresh:refreshToken}));
};
export const validacedula = async (body) => {
  return await post()(`cuenta/api/v1/validacedula/`, body);
};
export const findFases = (user, logout, userLoggedIn) => async (tipo) => {
  return await get(user,logout, userLoggedIn)(
    `tramites/api/v1/fases/${tipo ? "?tipo=" + tipo : ""}`
  );
};
export const findTramitedet = (user, logout, userLoggedIn) => async (body) => {
  return await post(user, logout, userLoggedIn)(`tramites/api/v1/tramitedet/`, body);
};

export const gExtTramitedet = (user, logout, userLoggedIn) => async (body) => {
  return await post(user, logout, userLoggedIn)(`tramites/api/v1/gdetalle/`, body);
};

export const checkstate = (user) => async (body) => {
  return await post(user)(`cuenta/api/v1/checkstate/`, body);
};
export const urlclave = async () => {
  return await post()(`cuenta/api/v1/urlclave/`);
};

export const getFavoritos = (user, logout, userLoggedIn) => async (tipo) => {
  return await get(user,logout, userLoggedIn)(
    `tramites/api/v1/favorites/`+tipo
  );
};

export const sendMailTest = (user, logout, userLoggedIn) => async () => {
  return await get(user,logout, userLoggedIn)(
    `tramites/api/v1/sendmail/`
  );
};

export const findTramites = (user, logout,userLoggedIn ) => async (body) => {
  return await post(user, logout,userLoggedIn)(`tramites/api/v1/tramites/`, body);
};

export const postGestionExterna = (user, logout,userLoggedIn ) => async (body) => {
  return await post(user, logout,userLoggedIn)(`tramites/api/v1/gexterna/`, body);
};

export const searchTramites = (token, logout,userLoggedIn) => async (body) => {
  return await post(token, logout,userLoggedIn)(`tramites/api/v1/tramites/search/`, body);
};

export const seguirTramite = (token, logout,userLoggedIn) => async (body) => {
  return await post(token, logout,userLoggedIn)(`tramites/api/v1/favorites/`, body);
};

export const dejarDeSeguirTramite = (token, logout,userLoggedIn) => async (body) => {
  return await delet(token, logout,userLoggedIn)(`tramites/api/v1/favorites/`, body);
};

export const logoutClaveUnica = async () => {
  return window.location.href=baseUrlClaveUnice;	
};

export const logout = async (user) => {
  const body = JSON.stringify({refresh:user.refresh})
  return post(user)(`cuenta/api/v1/logout/`, body)
};

export const PdfExpedienteView =  async (datosexp) => {
  
  // data = {'link_expediente':link_expediente, 'sistema_origen':link_expediente, 'intendencia':intendencia, 'rut': rut, 'folio': folio}
  const body = JSON.stringify({
    link_expediente: datosexp["link_expediente"],
    sistema_origen: datosexp["tipo_certificado"],
    intendencia: datosexp["ux"],
    rut: datosexp["identifier"],
    folio: datosexp["folio"],
  
  })
  return post()(`tramites/api/v1/pdfExpedienteView/`, body)
};


export const ginterna = (user, logout,userLoggedIn ) => async (body) => {
  return await post(user, logout,userLoggedIn)(`tramites/api/v1/ginterna/`, body);
};

  
export const getDatosCiudadanoPorRut = (user, logout, userLoggedIn) => async (rut) => {
  return await get(user,logout, userLoggedIn)(
    'api/v1/ciudadano?run=' + rut
);
};

export const getFileBase64 = (user, logout, userLoggedIn) => async (data) => {
  let url=`tramites/api/v1/gestiones/files/`+data.indice+`/`+data.folio+`/`+data.token+`/`+data.rut
  let req = await get(user,logout, userLoggedIn)(url);

  if (req.ok) {
    req = await req.json();
    return req;
  }
  return false;
};